import { i18nNsFactory } from '@atlas-frontend/i18n';
import { FieldPath, FieldValues } from 'react-hook-form';
import styled from 'styled-components';
import { Modal } from '../components';
import { useFormIdAttributePrefix } from './AdditionalFormContext';
import translations from './utils.translations.json';

const { addTranslations, t } = i18nNsFactory('algorithms-table');
addTranslations(translations);

export const useGetIdFromName = <T extends FieldValues>() => {
  const idAttributePrefix = useFormIdAttributePrefix<FormData>();

  return (name: FieldPath<T>) =>
    (idAttributePrefix ? [idAttributePrefix, name] : [name])
      .map((value) => value.toString().replace(/\./g, '-'))
      .join('-');
};

export const getNameFromId = <T extends FieldValues>(id: string) =>
  id.replace(/-/g, '.') as FieldPath<T>;

export const confirmPanelFormClose = (
  onOk?: () => void,
  onCancel?: () => void,
) => {
  Modal.confirm({
    title: t('confirm.title'),
    okText: t('confirm.okText'),
    cancelText: t('confirm.cancelText'),
    content: <ModalWrapper>{t('confirm.content')}</ModalWrapper>,
    onOk,
    onCancel,
  });
};

export const warningAlgorithmDirty = (onOk?: () => void) => {
  Modal.warning({
    title: t('warning.title'),
    okText: t('warning.okText'),
    content: <ModalWrapper>{t('warning.content')}</ModalWrapper>,
    onOk,
  });
};

export const ModalWrapper = styled.div`
  white-space: pre;
`;
